<button
    class="focus:outline-none disabled:opacity-50 text-white bg-red-600 outline-red-800 hover:bg-red-700 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:focus:ring-red-900"
    on:click
    type="button"
>
    <slot/>
</button
>
